import { UPDATE_SETTINGS } from "../actions/PerksSettings";
var initialState = {
    companyBenefits: {
        name: null,
        logoUrl: null
    }
};
var PerksSettingsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_SETTINGS:
            return Object.assign({}, state, action.settings);
        default:
            return state;
    }
};
export default PerksSettingsReducer;
